import { render, staticRenderFns } from "./wxBill.vue?vue&type=template&id=8991c450"
import script from "./wxBill.vue?vue&type=script&lang=js"
export * from "./wxBill.vue?vue&type=script&lang=js"
import style0 from "./wxBill.vue?vue&type=style&index=0&id=8991c450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports